import { render, staticRenderFns } from "./accessdenied.vue?vue&type=template&id=7b307804&scoped=true"
import script from "./accessdenied.vue?vue&type=script&lang=js"
export * from "./accessdenied.vue?vue&type=script&lang=js"
import style0 from "./accessdenied.vue?vue&type=style&index=0&id=7b307804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b307804",
  null
  
)

export default component.exports